
var	MinConstraint = function(axis,threshold){
	this.axis = axis;
	this.threshold = threshold;
};

MinConstraint.prototype.applyConstraint = function(p){
	if(p.getComponent(this.axis) < this.threshold){
		p.setComponent(this.axis, this.threshold);
	}
};

module.exports = MinConstraint;




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/physics2d/constraints/MinConstraint.js
// module id = 4647
// module chunks = 14